import { render, staticRenderFns } from "./folders-shared-with-me.vue?vue&type=template&id=73fc5672&scoped=true"
import script from "./folders-shared-with-me.vue?vue&type=script&lang=js"
export * from "./folders-shared-with-me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc5672",
  null
  
)

export default component.exports